import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { NbDialogService, NbIconComponent, NbMenuItem, NbMenuService } from '@nebular/theme';
import { Condition, ConditionEvaluatorService, OfbizField, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { take, takeUntil,takeWhile } from 'rxjs/operators';
import { LookUpDialogService } from '../lookup-dialog-container/look-up-dialog.service';
import { LookupDialogContainerComponent } from '../lookup-dialog-container/lookup-dialog-container.component';
import { ComponentConfig, ComponentState, OutGoingLink, Relation, SelectedValue } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { UpdateComponentStoreService } from '../update-component-store.service';
import { ViewContainersService } from '../shared/services/view-containers.service';

@Component({
  selector: 'ubs-edit-container',
  templateUrl: './edit-container.component.html',
  styleUrls: ['./edit-container.component.scss']
})
export class EditContainerComponent implements OnInit,OnDestroy,OnChanges {
  @Input() activeLevel:number;
  @Input() addForms:OfbizForm[];
  @Input() action:string;
  @Input() relations:Relation[];
  @Input() viewMode:any;
  @Input()
    set state(state:Observable<ComponentState>){
      state.subscribe(componentState => {
        console.log({ComponentStateInEdit:componentState});
        if(componentState.componentConfig != undefined){
          this.componentConfig = componentState.componentConfig;
          this.addForm = this.componentConfig.addForm;
        }
        if(componentState.action == "edit" || componentState.action == "master-detail"){
          this.selectedValue = componentState?.selectedValue;
          console.log({selectedValue:this.selectedValue});
          let formData = this.selectedValue?.data.formData;
          let formName = formData?.formName;
          this.setTarget(this.addForm);
          if(this.selectedValue != null){
            console.log("Getting value for selectedValue",this.selectedValue);
            this.getValue(this.selectedValue);
          }
          console.log({EditState:"It's an edit"});
        }else{
          console.log({EditState:"Not an edit"})
        }
        if(componentState.outGoingLink != undefined && componentState.outGoingLink != null){
          if(componentState.action == "edit"){
            this.setSelectedValueFromLink(componentState.outGoingLink,this.addForm)
          }
          
        }
        console.log({OutgoingLink:componentState.outGoingLink});
      })
    }
  componentConfig:ComponentConfig
  addForm:OfbizForm;
  tempForm = this.fb.group({}); // Used to get the default value from backend
  options:any = {};
  title:string;
  //state:any;
  selectedValue:SelectedValue;
  hasCustomView:boolean = false;
  customView:string;
  target:string;
  altTarget:string;
  parameters:any;
  findOpen:boolean = true;
  hasContextMenu = false;
  contextMenuItems:NbMenuItem[] = [];
  menuTitle:string;
  /**
   * 1. Subscribes to the lookupSelectedValue Observable in the LookUpDialogService
   * 2. Populates the lookupSelectedValue field
   */
  lookupSelectedValueSubscription:Subscription;
  /**
   * 1. Set by lookupSelectedValueSubscription
   * 2. Propvided as input to child components
   */
  lookupSelectedValue:any;
  /**
   * Boolean to only show form if value has been retrieved and set from backend
   */
  hasValue:boolean = false;

  private readonly destroy$ = new Subject<void>();

  selectedValue$:Subscription;


  @ViewChild("chevron", {read: ElementRef}) chevron: NbIconComponent;
  @ViewChild("container", {read: ElementRef}) container: ElementRef;

  @Output() popoverClosed = new EventEmitter<string>();

  constructor(private componentStore:UbsComponentStoreService,
    private ofbizFormsService:OfbizFormsService,
    private fb:FormBuilder,
    private dialogService: NbDialogService,
    private lookUpDialogService:LookUpDialogService,
    private viewContainerService:ViewContainersService,
    private updateComponentStoreService:UpdateComponentStoreService,
    private conditionEvaluatorService:ConditionEvaluatorService,
    private menuService:NbMenuService) { 
      this.menuService.onItemClick().subscribe(event => {
        console.log({Event:"ContextMenuItemClicked",TrackEvent:event});
        if(event?.item?.title){
          this.menuTitle = event.item.title;
        }
      })

    }

  ngOnInit(): void {
    this.selectedValue$ = this.componentStore.selectedValue$.pipe(takeUntil(this.destroy$)).subscribe(selectedValue => {
      console.log(this.selectedValue);
    })    
    /* this.componentStore.vm$.pipe(takeWhile(vm => vm.action == "edit"))
    .subscribe(data => {
      this.selectedValue = data["selectedValue"];
      if(this.selectedValue && data.action == "edit"){
        console.log({EditOninit:{action:data.action}});
        console.log({TrackSelectedValue:{component:"EditContainer",value:this.selectedValue}})
        let formData = this.selectedValue.data.formData;
        console.log("formData",formData);
        let formName = formData.formName;
        this.addForm = this.addForms.find(addForm => addForm.formName == formName);
        console.log({addForm:this.addForm});
        this.getValue(this.selectedValue);
      }

      }); */
      this.lookupSelectedValueSubscription = this.lookUpDialogService.getLookupSelectedValue()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if(data != null){
          this.lookupSelectedValue = data;
          console.log({Event:"Getting Lookedupvalue from LookUpDialogService",TrackLookupSelectedValue:data});
        }
      });
      /* this.relations = this.viewContainerService.getRelationsForActiveLevel(this.componentConfig,this.activeLevel);
      console.log({TrackRelations:{component:"EditContainerComponent",value:this.relations}})
       if(this.relations != undefined && this.relations.length > 0){
        console.log({ContextMenuItems:{relations:this.relations}});
        this.setContextMenu(this.relations);
        
      } */
  }

  setContextMenu(relations:Relation[]):void{
    let groups = [];
    relations.forEach(relation => {
      let menuItem:NbMenuItem = {title:""};
      if(relation.titleGroup != undefined && relation.titleGroup != null){
        if(!groups.includes(relation.titleGroup)) groups.push(relation.titleGroup);
      }else{
        menuItem.title = relation.title;
        if(menuItem.title == "Roles" || menuItem.title == "Parties" ){
          menuItem.icon = "people-outline"
        }
        if(menuItem.title == "Web Sites"){
          menuItem.icon = "globe-outline"
        }
        if(menuItem.title == "Store Email Settings"){
          menuItem.icon = "email-outline"
        }
        if(menuItem.title == "Store Promotions"){
          menuItem.icon = {"icon": "promotions","pack": "custom-icons"}
        }
        if(menuItem.title == "Catalogs" || menuItem.title == "Categories"){
          menuItem.icon = {"icon": "categories","pack": "custom-icons"}
        }
        if(menuItem.title == "Shipment Methods"){
          menuItem.icon = {"icon": "shipping","pack": "custom-icons"}
        }
        if(menuItem.title == "Payment Settings"){
          menuItem.icon = {"icon": "price-rules","pack": "custom-icons"}
        }
        if(menuItem.title == "Store Surveys"){
          menuItem.icon = {"icon": "surveys","pack": "custom-icons"}
        }
        if(menuItem.title == "Facilities"){
          menuItem.icon = {"icon": "facilities","pack": "custom-icons"}
        }
        if(menuItem.title == "Shipment Cost Estimates"){
          menuItem.icon = {"icon": "shipping-estimates","pack": "custom-icons"}
        }
        if(menuItem.title == "Financial Account Settings"){
          menuItem.icon = {"icon": "financial-account","pack": "custom-icons"}
        }
        if(menuItem.title == "Parent Categories"){
          menuItem.icon = {"icon": "parents-diagram","pack": "custom-icons"}
        }
        if(menuItem.title == "Child Categories"){
          menuItem.icon = {"icon": "chidren-diagram","pack": "custom-icons"}
        }
        if(menuItem.title == "Content"){
          menuItem.icon = {"icon": "web-content","pack": "custom-icons"}
        }
        if(menuItem.title == "Products"){
          menuItem.icon = {"icon": "products","pack": "custom-icons"}
        }
        this.contextMenuItems.push(menuItem);
      }
    });
    if(groups.length > 0){
      groups.forEach(groupTitle => {
        let group = relations.filter(element => element.titleGroup == groupTitle);
        let menuItem = {title:groupTitle,children:[]};
        if(group.length > 0){
          group.forEach(relation => {
            let childMenuItem = {title:relation.title};
            menuItem.children.push(childMenuItem);
          });
        }
        this.contextMenuItems.push(menuItem);
      })
    }
    this.hasContextMenu = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["addForms"] && this.activeLevel != undefined){
      console.log({TrackRelations:{activeLevel:this.activeLevel}});
      //this.addForm = this.addForms[this.activeLevel-1];
      console.log({altTargets:this.addForm.altTargets});
      if(this.addForm.renderComponent){
        this.hasCustomView = true;
        this.customView = this.addForm.renderComponent;
      }
      if(this.addForm.actionsMenu != undefined && this.addForm.actionsMenu.length > 0){

      }

      this.options.formName = this.addForm.formName;
      this.options.entityName = this.addForm.entityName;
      this.options.formLocation = this.addForm.formLocation;
      console.log({TitleStuff:{name:this.addForm.formName,descriptionField:this.addForm["titleDescriptionField"],idField:this.addForm["titleIdField"]}});
    }
    if(changes["action"]){
      console.log({actionChanged:this.action});
      if(this.action != "edit"){
        this.destroy$.next();
        this.destroy$.complete();
      }
    }
    if(changes["relations"]){
      this.relations = this.viewContainerService.getRelationsForActiveLevel(this.componentConfig,this.activeLevel);
      console.log({RelationsChanged:{component:"EditContainerComponent",value:this.relations}})
       if(this.relations != undefined && this.relations.length > 0){
        console.log({ContextMenuItems:{relations:this.relations}});
        this.setContextMenu(this.relations);
        
      }
    }
    if(changes["activeLevel"]){
      console.log({activeLevelChanged:this.activeLevel})
    }
  }

  setTarget(addForm:OfbizForm):void{
    let targets = addForm.targets? addForm.targets : null;
    if(targets != null){
      console.log({Targets:targets});
      this.target = targets["updateTarget"];
    }else if(this.addForm.target != null && this.addForm.target != undefined){
      console.log({"NoTARGETS":addForm.formName})
      this.target = this.addForm.target;
    }else{
      console.log({"NoTarget":addForm.formName})
    }
  }

  getValue(selectedValue:any):void{
    let formData = selectedValue.data.formData;
    let endPoint = selectedValue.data.endPoint;
    let parameters = selectedValue.data.parameters;
    if(parameters != undefined){
      Object.keys(parameters).forEach(key =>{
        if(this.tempForm.get(key)){
          console.log("Field exists",this.tempForm.get(key),{key:parameters[key]});
          this.tempForm.patchValue({[key]:parameters[key]});
        }else{
          this.tempForm.addControl(key,new FormControl(parameters[key]));
        }
      });
      console.log(this.tempForm.value);
    }
    console.log("Getting formData value",formData);
    this.ofbizFormsService.getValue(formData,this.tempForm.value,endPoint)
    .pipe(take(1))
    .subscribe(responseData => {
      const statusCode = responseData["statusCode"];
      switch (statusCode) {
        case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              //this.responseMessage = "success";
              //let formFields:OfbizField[] = this.addForm.fields;
              let dataFields:any[] = formData["fields"];
              console.log(dataFields);
              this.parameters = dataFields;
              let titlePlaceHolder:any = {"description":"","id":""}
              this.addForm.fields.forEach(field => {
                let dataField = dataFields.find(element => field.name == Object.keys(element)[0]);
                if(dataField){
                  field.value = dataField[field.name];
                  if(field.name === this.addForm.titleDescriptionField){
                    titlePlaceHolder.description = dataField[field.name];
                  }
                  if(field.name === this.addForm.idFieldName){
                    titlePlaceHolder.id = dataField[field.name];
                  }
                }
              });
              console.log({AddFormAfter:this.addForm});
              if(this.addForm.actionsMenu != undefined){
                this.processActionMenu();
                console.log(this.addForm.actionsMenu);
                this.contextMenuItems = this.addForm.actionsMenu;
              }
              this.title = titlePlaceHolder.description+" - ["+titlePlaceHolder.id+"]";
              console.log(this.title);
              this.hasValue = true;
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    })
  }

  setSelectedValueFromLink(link:OutGoingLink,addForm:OfbizForm):void{
    this.updateComponentStoreService.setOutGoingLink(null);
    let linkSelectedValue = {
      data:{
        formData:{
          formLocation:addForm.formLocation,
          formName:addForm.formName
        },
        parameters:link.parameters,
      },
      type:link.target,

    }
    this.selectedValue = linkSelectedValue;
    this.updateComponentStoreService.setSelectedValue(linkSelectedValue);
    
    //this.getValue(linkSelectedValue);
  }
  /**
   * @comment 1. Used with lookupField
   * 1. Listen for the openDialogContainerEvent
   * 2. Receives input as data including details of the requesting field
   * 3. Opens LookupDialogContainerComponent
   * 4. Emits the selected value on close
   * @param data about the requesting field
   */
  openDialogContainer(data):void{
    console.log({TrackDialog:{component:"EditContainerComponent",data:data}});
    //let componentConfig:ComponentConfig = this.state.componentConfig;
    this.dialogService.open(LookupDialogContainerComponent, {
      context:{
        componentConfig:this.componentConfig,
        data:data
      },
      dialogClass:'modal-full',
    })
  }
  processActionMenu():void{
    this.addForm.actionsMenu.forEach((menuItem,i) => {
      //Populate parameter object
      let parameters = menuItem.data.parameters;
      if(parameters != undefined && parameters != null){
        for(let[k,v] of Object.entries(parameters)){
          let valueField = this.addForm.fields.find(field => field.name == k);
          if(valueField) {
            parameters[k] = valueField.value;
          }         
        }
      }
      //Remove conditional menuItems that doesn't pass the condition-evaluator test
      if(menuItem.data.condition != undefined && menuItem.data.condition != null){
        //Get the fields to evaluate
        let evalFields = [];
        let condition:Condition = menuItem.data.condition;
        //Set the actual values
        //First check if there are nested conditions
        if(condition.nestedConditions != undefined && condition.nestedConditions != null){
          evalFields = this.getNestedFields(condition.nestedConditions,evalFields);              
        }
        //Check single field
        if(menuItem.data.condition.field != undefined && menuItem.data.condition.field != null){
          if(!evalFields.includes(condition.field)){
            evalFields.push(condition.field);
          }       
        }
        console.log(evalFields);
        //Create the actualValues object consistinf of evalField with actual values from the form field
        if(evalFields.length > 0){
          let actualValues = {};
          evalFields.forEach(evalField => {
            let actualField = this.addForm.fields.find(field => field.name == evalField);
            actualValues[evalField] = actualField.value;
          })
          console.log(actualValues);
          //Execute the evaluation
          let evalResult = this.conditionEvaluatorService.evaluate(actualValues, condition);
          console.log(evalResult);
          if(evalResult == false){
            this.addForm.actionsMenu.splice(i,1);
          }
        }
      }
    })
  }

  getNestedFields(nestedConditions:Condition[],evalFields:any[]):any[]{
    evalFields;
    nestedConditions.forEach(condition => {
      if(!evalFields.includes(condition.field)){
        evalFields.push(condition.field);
      }
      if(condition.nestedConditions != undefined && condition.nestedConditions != null){
        this.getNestedFields(condition.nestedConditions,evalFields);
      }
    })
    return evalFields;
  }

  toggleIcon(){
    console.log(this.chevron);
    if(this.findOpen){
      this.findOpen = false;
      this.container.nativeElement.style.display = "none";
    }else{
      this.findOpen = true;
      this.container.nativeElement.style.display = "block";
    }
  }
  togglePopover(){
    this.popoverClosed.emit();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
